@if (isLoaded()) {
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="modal-body">
      <div class="row">
        <rask-input class="col-4"
          aid="inputViolId"
          label="Viol ID"
          formControlName="violId"
          [required]="true"
          [disabled]="!isNew()"
          [raskRule]="validationContext.current.violId"
          ruleContainerId="validationContainer">
        </rask-input>
        <rask-input class="col-4"
          aid="inputBenamning"
          label="Benämning"
          formControlName="benamning">
        </rask-input>
        @if (shouldShowVLG()) {
          <rask-checkbox class="col-4"
            aid="checkboxVidLeveransGallande"
            text="Vid leverans gällande"
            formControlName="vidLeveransGallande">
          </rask-checkbox>
        }
      </div>
      <div class="row">
        <rask-datepicker class="col-4"
          aid="inputGallerFrom"
          formControlName="gallerFrom"
          label="Gäller fr.o.m."
          [onlyMonths]="false"
          [required]="true"
          [raskRule]="validationContext.current.gallerFrom"
          ruleContainerId="validationContainer">
        </rask-datepicker>
        <rask-datepicker class="col-4"
          aid="inputGallerTom"
          formControlName="gallerTom"
          label="Gäller t.o.m."
          [onlyMonths]="false">
        </rask-datepicker>
        <rask-checkbox class="col-4"
          aid="checkboxAktuell"
          text="Aktuell"
          formControlName="aktuell"
          infoText="Aktuella marknadsprislistor visas direkt vid skapandet av virkesköpskontrakt. Inaktuella marknadsprislistor visas endast om virkesköpare aktivt väljer att se dem.">
        </rask-checkbox>
      </div>
      <div class="row">
        <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
        @if (marknadsomrade != null) {
          <rask-multi-selector class="col-8"
            aid="inputResultatomraden"
            label="Region"
            [items]="getMarknadsomrade()"
            bindLabel="namn"
            groupBy="group"
            formControlName="resultatomraden"
            [required]="true"
            [selected]="form.value.resultatomraden"
            [raskRule]="validationContext.current.resultatomraden"
            ruleContainerId="validationContainer">
          </rask-multi-selector>
        }
        <rask-radiobutton-group class="col-8" label="Används för" [buttons]="anvandsFor"
          formControlName="typ"></rask-radiobutton-group>

      </div>
      <div class="row">
        <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
        @if (handelssortimentGrupper != null) {
          <rask-multi-selector class="col-12"
            aid="inputHandelssortimentsgrupper"
            label="Handelssortimentsgrupp"
            [items]="getHandelssortimentsgrupper()"
            bindLabel="namn"
            formControlName="handelssortimentsgrupper"
            [selected]="form.value.handelssortimentsgrupper">
          </rask-multi-selector>
        }
      </div>
    </div>
    <div class="modal-footer">
      <rask-validation-message-container id="validationContainer">
      </rask-validation-message-container>
      <rask-button (click)="save()" [disabled]="!canSave()">Spara</rask-button>
      @if (!isNew()) {
        <rask-button aid="buttonRadera" color="secondary" negative (click)="radera()">Ta bort marknadsprislista</rask-button>
      }
      <rask-button aid="buttonAvbryt" color="tertiary" (click)="tryClose(true)" ngbAutofocus>Avbryt</rask-button>
    </div>
  </form>
}
